import React from 'react';
import styled from 'styled-components';

import media from '../utils/mediaQueries';

const Holder = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  position: relative;

  .gatsby-image-wrapper {
    width: 100%;
    height: auto;

    ${props =>
      !props.relativeHeightXs &&
      `
      position: static !important;
      height: 100%;

      > div {
        display: none;
      }

      img {
        object-fit: contain !important;
      }
    `}

    ${media.md`
      ${props =>
        !props.relativeHeightMd &&
        `
        position: static !important;
        height: 100%;

        > div {
          display: none;
        }

        img {
          object-fit: contain !important;
        }
      `}
    `}
  }
`;

export default props => <Holder {...props}>{props.children}</Holder>;
